"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidBIC11 = exports.isValidBIC8 = exports.isValidBIC = void 0;
const validISO31661Alpha2CountriesCodes_1 = require("../constants/validISO31661Alpha2CountriesCodes");
const BIC_REGEX = /^([A-Z0-9]{4})([A-Z]{2})([A-Z0-9]{2})([A-Z0-9]{3})?$/;
const BIC8_REGEX = /^([A-Z0-9]{4})([A-Z]{2})([A-Z0-9]{2})$/;
const BIC11_REGEX = /^([A-Z0-9]{4})([A-Z]{2})([A-Z0-9]{2})([A-Z0-9]{3})$/;
const BIC_REGEX_MAP = {
    BIC: BIC_REGEX,
    BIC11: BIC11_REGEX,
    BIC8: BIC8_REGEX,
};
const isValidISO31661Alpha2CountryCode = (countryCode) => validISO31661Alpha2CountriesCodes_1.validISO31661Alpha2CountriesCodes.includes(countryCode);
// Internal method
// eslint-disable-next-line no-underscore-dangle
const _isValidBIC = ({ bic, format = 'BIC', }) => {
    const regex = BIC_REGEX_MAP[format];
    const result = bic.match(regex);
    if (result === null) {
        return false;
    }
    const [isoCountryCode] = result;
    if (isValidISO31661Alpha2CountryCode(isoCountryCode)) {
        return false;
    }
    return true;
};
/**
 * Check if the BIC is valid (8 or 11 chars are acceptable here)
 * @param {string} bic - The bic to validate
 * @returns {boolean} - Whether the bic is valid
 */
const isValidBIC = (bic) => _isValidBIC({ bic, format: 'BIC' });
exports.isValidBIC = isValidBIC;
/**
 * Check if the BIC with 8 chars only is valid
 * @param {string} bic - The bic to validate
 * @returns {boolean} - Whether the bic is valid
 */
const isValidBIC8 = (bic) => _isValidBIC({ bic, format: 'BIC8' });
exports.isValidBIC8 = isValidBIC8;
/**
 * Check if the BIC with 11 chars only is valid
 * @param {string} bic - The bic to validate
 * @returns {boolean} - Whether the bic is valid
 */
const isValidBIC11 = (bic) => _isValidBIC({ bic, format: 'BIC11' });
exports.isValidBIC11 = isValidBIC11;
